module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-wrap"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8 text-center col-sm-offset-2 col-md-6 col-md-offset-3 col-lg-4 col-lg-offset-4 push-50-t"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/logo-login.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "push-50-t"
  }, [_vm._v(_vm._s(_vm.labelFieldTitle[_vm.actualLanguage]))]), _vm._v(" "), (_vm.errorMsg) ? _c('div', {
    staticClass: "alert push-30-t alert-danger alert-dismissable"
  }, [_c('p', [_vm._v(_vm._s(_vm.errorMsg))])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "push-30-t"
  }, [_vm._v(_vm._s(_vm.labelFieldMessage[_vm.actualLanguage]))]), _vm._v(" "), _c('form', {
    staticClass: "simple_form form-horizontal push-50-t"
  }, [_c('div', {
    staticClass: "form-inputs"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-material form-material-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInfos.email),
      expression: "userInfos.email"
    }],
    staticClass: "form-control string text optional form-control",
    attrs: {
      "autofocus": "autofocus",
      "type": "text",
      "value": "",
      "id": "user_email"
    },
    domProps: {
      "value": (_vm.userInfos.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userInfos, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "user_email"
    }
  }, [_vm._v(_vm._s(_vm.labelFieldEmail[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-material form-material-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInfos.verifyCode),
      expression: "userInfos.verifyCode"
    }],
    staticClass: "form-control string text optional form-control",
    attrs: {
      "autofocus": "autofocus",
      "type": "text",
      "value": "",
      "id": "user_verifyCode"
    },
    domProps: {
      "value": (_vm.userInfos.verifyCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userInfos, "verifyCode", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "user_verifyCode"
    }
  }, [_vm._v(_vm._s(_vm.labelFieldConfirmationCode[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('div', {
    staticClass: "col-xs-12 text-center push-30-t"
  }, [(!_vm.isVerifying) ? _c('button', {
    staticClass: "btn btn-connexion btn-success",
    staticStyle: {
      "min-width": "250px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submitVerification
    }
  }, [_vm._v(_vm._s(_vm.labelFieldButtonVerify[_vm.actualLanguage]))]) : _c('spinner')], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 text-center",
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.labelFieldAlready[_vm.actualLanguage]) + "\n        "), _c('router-link', {
    staticClass: "btn btn-default btn-rounded",
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.labelFieldButtonLogIn[_vm.actualLanguage]) + "\n        ")])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e06bf58","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/session/Verify.vue
// module id = 1492
// module chunks = 4